module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "gray-back page-ability-success"
  }, [_vm._m(0), _vm._v(" "), (_vm.loaded && _vm.qunQrcodeDisplayList.length) ? _c('van-divider', [_vm._v("群二维码")]) : _vm._e(), _vm._v(" "), (_vm.loaded && _vm.qunQrcodeDisplayList.length) ? _c('div', {
    staticClass: "qrcode-block"
  }, _vm._l((_vm.qunQrcodeDisplayList), function(url, idx) {
    return _c('div', {
      key: idx,
      staticClass: "qrcode-item"
    }, [_c('img', {
      staticClass: "qrcode-img",
      attrs: {
        "src": url,
        "alt": "群二维码"
      }
    })])
  }), 0) : _vm._e(), _vm._v(" "), (_vm.loaded) ? _c('van-cell-group', [_c('van-cell', {
    attrs: {
      "title": "单位",
      "value": _vm.detail.danwei || '—',
      "input-align": "right"
    }
  }), _vm._v(" "), _c('van-cell', {
    attrs: {
      "title": "联系人",
      "value": _vm.detail.ldname || '—',
      "input-align": "right"
    }
  }), _vm._v(" "), _c('van-cell', {
    attrs: {
      "title": "联系电话",
      "value": _vm.detail.phone || '—',
      "input-align": "right"
    }
  }), _vm._v(" "), _c('van-cell', {
    attrs: {
      "title": "年份",
      "value": _vm.detail.saiji_text || '—',
      "input-align": "right"
    }
  }), _vm._v(" "), _c('van-cell', {
    attrs: {
      "title": "场次",
      "value": _vm.detail.saiqu_text || '—',
      "input-align": "right"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.loaded && _vm.members.length) ? _c('van-divider', [_vm._v("报名人员")]) : _vm._e(), _vm._v(" "), (_vm.members.length) ? _c('van-cell-group', _vm._l((_vm.members), function(m, index) {
    return _c('van-cell', {
      key: index,
      attrs: {
        "title": '人员' + (index + 1),
        "value": m.name || '—',
        "input-align": "right"
      },
      scopedSlots: _vm._u([{
        key: "label",
        fn: function() {
          return [_c('span', {
            staticClass: "cell-label"
          }, [_vm._v(_vm._s(m.num) + " \n          "), _c('br'), _vm._v("\n          " + _vm._s(m.project) + _vm._s(m.grade))])]
        },
        proxy: true
      }], null, true)
    })
  }), 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "savebtn"
  }, [_c('van-button', {
    staticStyle: {
      "width": "3rem"
    },
    attrs: {
      "color": "linear-gradient(90deg, rgb(254, 200, 53) 0%, rgb(255, 173, 25) 100%)",
      "size": "normal",
      "round": ""
    },
    on: {
      "click": _vm.backList
    }
  }, [_vm._v("返回列表\n    ")]), _vm._v(" "), _c('van-button', {
    staticStyle: {
      "width": "3rem"
    },
    attrs: {
      "size": "normal",
      "round": ""
    },
    on: {
      "click": _vm.toMember
    }
  }, [_vm._v("人员信息\n    ")])], 1)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "order-success"
  }, [_c('div', {
    staticClass: "icon"
  }), _vm._v(" "), _c('div', {
    staticClass: "title"
  }, [_vm._v("申报成功")]), _vm._v(" "), _c('p', {
    staticClass: "sub"
  }, [_vm._v("您已完成能力测试报名，如需修改请联系工作人员。")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-fdfe4a6c","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/page/user/skill/AbilityApplySuccess.vue
// module id = 2649
// module chunks = 0